<template>
  <Panel name="ارزیابی محصولات تبرک" class="mt-10">
    <form action="">
      <Select
        class="text-sm"
        v-for="(question) in tabarokQuestion"
        :key="question"
        v-model="question.score"
      >
        <option value="" selected disabled>{{ question.question }}</option>
        <option value="0">کم</option>
        <option value="1">متوسط</option>
        <option value="2">زیاد</option>
      </Select>
      <router-link to="/survey/competitor-analyze">
        <Button class="w-full mt-4" @click="submitTabarokQuestion"
          >ادامه</Button
        >
      </router-link>
    </form>
  </Panel>
</template>
<script>
import Panel from "../../components/Panel";
import Select from "../../components/Select";
import Button from "../../components/Button";
import tabarokQuestion from "../../data/tabarokQuestion";
export default {
  name: "Questionnaire",
  components: { Button, Select, Panel },
  data() {
    return {
      tabarokQuestion: tabarokQuestion,
    };
  },
  methods: {
    submitTabarokQuestion() {
      this.$store.dispatch("setTabarokQuestions", this.tabarokQuestion);
    },
  },
};
</script>
